import { render, staticRenderFns } from "./responses-content.vue?vue&type=template&id=783e8f04&scoped=true"
import script from "./responses-content.vue?vue&type=script&lang=js"
export * from "./responses-content.vue?vue&type=script&lang=js"
import style0 from "./responses-content.vue?vue&type=style&index=0&id=783e8f04&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783e8f04",
  null
  
)

export default component.exports